var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSimplified = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "invoice (3)",
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6452"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6451"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6123",
  d: "M95.787 72.822a6.319 6.319 0 0 1-6.319 6.319H49.444v4.213h40.023a10.545 10.545 0 0 0 10.532-10.532Z"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6454"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6453"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6124",
  d: "M33.7 78.935H10.532a6.319 6.319 0 0 1-6.319-6.319V26.274a6.319 6.319 0 0 1 6.319-6.319h16.852v-4.214H10.532A10.545 10.545 0 0 0 0 26.274v46.343a10.545 10.545 0 0 0 10.532 10.531H31.6v4.424a9.878 9.878 0 0 0-8.426 10.322h4.213a6.008 6.008 0 0 1 6.319-6.319 2.107 2.107 0 0 0 2.107-2.107v-8.426a2.106 2.106 0 0 0-2.113-2.107Z"
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6456"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6455"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6125",
  d: "M68.694 87.572v-6.53h-4.213v8.426a2.107 2.107 0 0 0 2.107 2.107 6.01 6.01 0 0 1 6.319 6.319h4.213a9.877 9.877 0 0 0-8.426-10.322Z"
})))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6458"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6457"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2575",
  d: "M18.403 95.787h63.194V100H18.403z"
})))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6460"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6459"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2576",
  d: "M33.259 87.361h16.852v4.213H33.259z"
})))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6462"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6461"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2577",
  d: "M2.107 64.552h25.278v4.213H2.107z"
})))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6464"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6463"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6126",
  d: "M14.745 24.968a6.319 6.319 0 0 0-6.319 6.319V35.5h4.213v-4.213a2.107 2.107 0 0 1 2.107-2.107h4.213v-4.212Z"
})))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6466"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6465"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6127",
  d: "M89.603 0H25.142a10.465 10.465 0 0 0-10.4 10.532v8.426h4.159v-8.426a6.374 6.374 0 0 1 2.047-4.676 6.133 6.133 0 0 1 4.194-1.643h.081c.179 0 .358.013.543.029a6.545 6.545 0 0 1 5.612 6.653v52.3a6.279 6.279 0 0 0 6.238 6.319h56.143a6.279 6.279 0 0 0 6.238-6.319V10.532A10.478 10.478 0 0 0 89.603 0Zm6.238 63.194a2.093 2.093 0 0 1-2.079 2.107H37.618a2.093 2.093 0 0 1-2.079-2.107v-52.3a11.2 11.2 0 0 0-2.206-6.682h56.27a6.279 6.279 0 0 1 6.238 6.319Z"
})))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6468"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6467"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6128",
  d: "M83.148 22.88v4.213a2.107 2.107 0 1 1-2.106 2.107h-4.213a6.319 6.319 0 1 0 6.319-6.319Z"
})))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6470"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6469"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6129",
  d: "M70.8 10.532a6.32 6.32 0 0 0 0 12.639v-4.213a2.107 2.107 0 1 1 2.107-2.107h4.213a6.319 6.319 0 0 0-6.32-6.319Z"
})))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6472"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6471"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2578",
  d: "M64.807 32.215 85.872 11.15l2.979 2.98-21.065 21.064z"
})))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6474"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6473"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2579",
  d: "M43.483 54.14h35.81v4.213h-35.81z"
})))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6476"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6475"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2580",
  d: "M43.125 43.729h44.236v4.213H43.125z"
})))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6478"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6477"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2581",
  d: "M43.681 33.317H56.32v4.213H43.681z"
})))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6480"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6479"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2582",
  d: "M43.681 22.906H56.32v4.213H43.681z"
})))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6482"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6481"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2583",
  d: "M43.681 12.639H56.32v4.213H43.681z"
})))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6484"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6483"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 2584",
  d: "M83.148 54.14h4.213v4.213h-4.213z"
})))));
export default SvgSimplified;